const topics = [
  { label: '国产剧情', hot: true },
  { label: '91传媒视频', hot: true },
  { label: '高清合集', hot: false },
  { label: '每日更新', hot: true },
  { label: '国产经典', hot: false },
  { label: '91国产小视频', hot: true },
  { label: '悬疑推理', hot: false },
  { label: '都市情感', hot: false },
  { label: '喜剧短片', hot: false },
  { label: '动作大片', hot: false },
  { label: '91年国产影片', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            探索当前最受关注的国产免费视频话题标签，发现更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <span
              key={topic.label}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 border border-primary-200/60 hover:bg-primary-200/60'
                  : 'bg-background-50 text-foreground-700 border border-background-200/60 hover:bg-background-200/50'
              }`}
            >
              {topic.label}
              {topic.hot && (
                <i className="ri-fire-line text-primary-500 text-xs w-4 h-4 flex items-center justify-center"></i>
              )}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}